import {Component} from "@angular/core";
import {Base} from "../../../../../../common/interfaces/base.interfaces";


@Component({
    selector: "section-warehouse-transactions-invalid",
    template: `
        <section-warehouse-transactions-list [params]='{title: "Invalid transactions", type: "invalid", state: state}'>
        </section-warehouse-transactions-list>`
})
export class WarehouseTransactionsListInvalidComponent implements Base.IComponent {

    public readonly state: Base.IState;

    public ngConfig(): Base.IConfig {
        return {
            name: "transactions-invalid",
            actions: {
                "browse": ["browse_warehouse_transactions"]
            }
        };
    }

}
